interface CouponCheckoutProps {
  register: any;
  setValue: Function;
  handleApplyCoupon: () => void;
  couponState: {
    code?: string;
    error?: string;
  };
}

export default function CouponCheckout({ register, setValue, handleApplyCoupon, couponState }: CouponCheckoutProps) {
  return (
    <div className="mt-2 flex flex-col">
      {/* Label */}
      <label htmlFor="couponCode" className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
        Coupon Code
      </label>

      {/* ⭐ This is now the alignment anchor */}
      <div className="flex items-center gap-2" id="coupon-input-row">
        <input
          id="couponCode"
          type="text"
          placeholder="Enter code"
          {...register("couponCode")}
          className="border rounded px-2 py-2 w-28 md:w-40 uppercase"
          onChange={(e) => setValue("couponCode", e.target.value.toUpperCase())}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleApplyCoupon();
            }
          }}
        />
        <button type="button" onClick={handleApplyCoupon} className="bg-[#d8bd80] text-white px-4 py-2 rounded">
          Apply
        </button>
      </div>

      {/* Feedback */}
      <div className="h-5 mt-1 flex items-center">
        {couponState?.error && <span className="text-red-600 text-xs">{couponState.error}</span>}
        {couponState?.code && !couponState?.error && (
          <span className="text-green-700 text-xs">
            Coupon <strong>{couponState.code}</strong> applied successfully
          </span>
        )}
      </div>
    </div>
  );
}
